<template>
  <div v-if="isVisible()">
    <button v-if="!isDisabled()" class="rounded-full" @click="perform">
      <span :class="'pi ' + params.icon" data-pc-section="icon"> </span>
    </button>
    <button v-if="isDisabled()" class="rounded-full" @click="perform" disabled>
      <span :class="'pi ' + params.icon" data-pc-section="icon"> </span>
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const isVisible = (): boolean => {
  if (props.params.checkVisible != null) return props.params.checkVisible(props.params.data);
  return true;
};

const isDisabled = (): boolean => {
  if (props.params.checkDisabled != null) return props.params.checkDisabled(props.params.data);
  return false;
};

const perform = (): void => {
  if (props.params?.callback != null) props.params.callback(props.params.data);
};
</script>
